export default __webpack_public_path__ + "static/media/De’Nicea_Hilton_Harper_AHV_In_Moms_We_Trust.9055df40.jpg";